// extracted by mini-css-extract-plugin
module.exports = {"bubble":"ChatBubbleButton--bubble--22p63","icon":"ChatBubbleButton--icon--JUhhj"};